import IconWithTooltip from "../../../../../../components/IconWithTooltip";
import { FaExclamationTriangle } from "react-icons/fa";

export default function ValidationStateIndicator({
  errorText,
  show,
}: {
  errorText: string;
  show: boolean;
}) {
  return (
    <>
      {show && errorText && (
        <IconWithTooltip
          label={errorText}
          tooltipProps={{
            hasArrow: true,
            bg: "red.400",
            color: "white",
            placement: "bottom-end",
            height: "100%",
          }}
          iconContainerProps={{ pt: 0 }}
          h="3"
          w="3"
          color="red.400"
          icon={FaExclamationTriangle}
          mr={2}
        />
      )}
    </>
  );
}
